import { AuthContext } from "@redotech/redo-merchant-app-common/auth";
import { useContext } from "react";
import { autoOnboardingUrl } from ".";

/**
 * Route component that redirects the user to the onboarding app with their
 * current auth token.  Used by the onboarding login modal so the flow is:
 *
 *   setup-vite (expired) → merchant login → /onboarding-redirect → setup-vite?token=…
 */
export function OnboardingRedirect() {
  const auth = useContext(AuthContext);

  if (auth) {
    location.href = autoOnboardingUrl(auth.token, auth.teamId).toString();
  }

  return null;
}
